const trainSystem = {
  path: "/trainSystem", // 主体
  name: "trainSystem",
  redirect: "/talentPoolManage",
  component: () => import("../views/trainSystem/main"),
  children: [
    {
      path: "/questionbankManage",
      name: "questionbankManage",
      meta: {
        title: "题库管理"
      },
      component: () =>
          import("../views/trainSystem/questionbankManage/questionbankManage.vue")
    },
    {
      path: "/onlineExaminManage",
      name: "onlineExaminManage",
      meta: {
        title: "在线考试"
      },
      component: () =>
          import("../views/trainSystem/onlineExaminManage/onlineExaminManage.vue")
    },
    {
      path: "/talentPoolManage",
      name: "talentPoolManage",
      meta: {
        title: "人才库管理"
      },
      component: () =>
          import("../views/trainSystem/talentPoolManage/talentPoolManage.vue")
    },
    {
      path: "/tranCourseManage",
      name: "tranCourseManage",
      meta: {
        title: "培训课程"
      },
      component: () =>
          import("../views/trainSystem/tranCourseManage/tranCourseManage.vue")
    },
   
  ]
}
export default trainSystem
